import { isNullOrUndefined } from '@syncfusion/ej2-base';
/**
 * @private
 */
export class WLevelOverride {
    /**
     * @private
     * @returns {void}
     */
    clear() {
        if (!isNullOrUndefined(this.overrideListLevel)) {
            this.overrideListLevel.clearFormat();
        }
        this.overrideListLevel = undefined;
    }
    /**
     * Disposes the internal objects which are maintained.
     * @private
     * @returns {void}
     */
    destroy() {
        if (!isNullOrUndefined(this.overrideListLevel)) {
            this.overrideListLevel.destroy();
        }
        this.levelNumber = undefined;
        this.startAt = undefined;
        this.overrideListLevel = undefined;
    }
    clone() {
        const levelOverride = new WLevelOverride();
        levelOverride.startAt = this.startAt;
        levelOverride.levelNumber = this.levelNumber;
        if (!isNullOrUndefined(this.overrideListLevel)) {
            levelOverride.overrideListLevel = this.overrideListLevel.clone(levelOverride);
        }
        return levelOverride;
    }
}
